import { render } from "./SystemAdmin15.vue?vue&type=template&id=98b49bae"
import script from "./SystemAdmin15.vue?vue&type=script&lang=js"
export * from "./SystemAdmin15.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__